/*global $,jQuery*/
/*import { cwColors, cwCategories, cwEngravingColors, cwSymbols } from './cwColors-2.js';*/

(function () {
    "use strict";
    function CWDESIGNSTUDIO() {

        const cwDS = {
            pageRoot: $("#pageRoot").prop("value"),
            productRoot: $("#appSetProductsRoot").prop("value") + $("#productSEName").prop("value"),
            productSEName: $("#productSEName").prop("value"),
            ProductID: $("#ProductID").prop("value"),
            productPartsVersion: $("#productPartsVersion").prop("value"),
            dsVersion: 4,
            productName: $("#productName").prop("value"),
            cwWindow: $(window),
            maxProductSize: $("#maxProductSize").prop("value"),
            pagePath: $("#basePagePath").prop("value"),
            brainstormCap: 3,
            imageFormat: $("#productPartsVersion").prop("value").includes("-webp") ? "webp" : "png",
            hasProductImages: $("#hasProductImages").prop("value") === 'true',
        };
        const canvasImageType = { image: 'image', engraving: 'engraving' };
        const engravingImages = {};
        const cartImages = {};
        let currentRenderController = null;

        let engTimer;
        let studio;

        /*======== START section from kitProduct.js ===========*/
        const settings = {
            dropdownSelector: '.js-kit-select',
            kitSummarySelector: '.js-kit-summary',
            kitItemNameSelector: '.js-kit-name-display',
            url: '/shoppingcart/ajaxgetkitdata' // url gets passed in from the _KitAddToCartForm.cshtml file
        };
        var updatePageDisplay = function(form, summaryContents, itemDisplayNames) {
            if (summaryContents && summaryContents.length > 0) {
                $(form).find(settings.kitSummarySelector).html(summaryContents);
            }
            if (itemDisplayNames) {
                for (var key in itemDisplayNames) {
                    if (itemDisplayNames.hasOwnProperty(key)) {
                        var selector = `${settings.kitItemNameSelector}[data-kit-item-id="${key}"]`;
                        $(selector).html(itemDisplayNames[key]);
                        $(settings.dropdownSelector).find(`option[value="${key}"]`).html(itemDisplayNames[key]);
                    }
                }
            }
        };
        var getKitSummary = function(form) {
            $.ajax({
                type: 'POST',
                url: settings.url,
                data: $(form).serialize(),
                success: function(data) {
                    if (data) {
                        updatePageDisplay(form, data.SummaryHtml, data.ItemDisplayNames);
                    }
                }
            });
        };
        /*======== END section from kitProduct.js ===========*/



        this.initMutationObserver = function() {
            // Function to handle mutations
            const mutationHandler = (mutationsList, observer, callback) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        callback();
                    }
                }
            };

            // Observer for .product__info-container
            const productInfoObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub);
            });

            const productInfoElement = document.querySelector(".product__info-container");
            if (productInfoElement) {
                productInfoObserver.observe(productInfoElement, { childList: true, subtree: true });
            }

            // Observer for .js-kit-summary
            const kitSummaryObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub2);
            });

            const kitSummaryElement = document.querySelector(".js-kit-summary");
            if (kitSummaryElement) {
                kitSummaryObserver.observe(kitSummaryElement, { childList: true, subtree: true });
            }

            // Observer for .bcpo input[type='checkbox']
            const bcpoObserver = new MutationObserver((mutationsList, observer) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        if ($(".bcpo input[type='checkbox']").length > 0) {
                            $(".bcpo").off("change", "input").on("change", "input", function() {
                                this.updateProductPrice();
                            }.bind(this)); // Ensure 'this' refers to CWDESIGNSTUDIO instance
                            observer.disconnect();
                        }
                    }
                }
            });

            bcpoObserver.observe(document.body, { childList: true, subtree: true });

        }.bind(this);

        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }

        function capitalizeWords(string) {
            return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }

        function createCombinedImageWithValues() {
            let combineURL = $("#appSetCombineCall").prop("value"), productSEName, productID, colorsURL, parts;
            productSEName = cwDS.productSEName;
            productID = cwDS.ProductID;
            colorsURL = $("#saveDesignURL").prop("value");
            colorsURL = getRequestValue("c");
            parts = $("#partFilesUrl").prop("value");
            combineURL = `${combineURL}?ProductID=${productID}&productSEname=${productSEName}&productDSVersion=${cwDS.dsVersion}`;
            combineURL = `${combineURL}&colorsurl=${colorsURL}&parts=${parts}&partsVersion=${cwDS.productPartsVersion}`;
            /*$.ajax({
                url: combineURL,
                dataType: "jsonp",
                jsonpCallback: "successCallback"
            });*/
            
            return false;
        }

        function createCombinedImage() {
            if (cwDS.pagePath === undefined) { return false; }
            if (getRequestValue("splash") 
              || cwDS.pagePath.toLowerCase().indexOf("promotional.aspx") >= 0 
              || cwDS.pagePath.toLowerCase().search(/\d(-skins)/g) >= 0) { 
                return false; 
            }
            createCombinedImageWithValues();
        }



        function getRequestValue(name){
            if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
            return decodeURIComponent(name[1]);
        }

        function dsIsNaN (n) {
            return typeof(n) === 'number' && isNaN(n);
        }

        function dataURItoBlob(dataURI) {
            let binary = atob(dataURI.split(',')[1]), array = [];
            for(let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: 'image/png'});
        }

        function paletteScroll() {
            let partPanel, studioPanel, curAngle, angleNeeded, partsScrollLeft, partsWidth, studioScrollLeft, studioWidth;
            partPanel = $(".palette > ul");
            studioPanel = $(".studio > ul");
            partsScrollLeft = partPanel.scrollLeft();
            partsWidth = partPanel.width();
            studioScrollLeft = studioPanel.scrollLeft();
            studioWidth = studioPanel.width();
            curAngle = Math.round(studioScrollLeft/studioWidth) + 1;
            angleNeeded = partPanel.find(" > li").eq(Math.round(partsScrollLeft/partsWidth)).data("angle");
          
            if (curAngle !== angleNeeded ) {
                studioPanel.toggleClass("scrollMode");
                studioPanel.stop(true, true).animate({scrollLeft: parseInt((angleNeeded -1) * (studioWidth), 10)}, 600, function() {
                    studioPanel.toggleClass("scrollMode");
                });
            }
        }

        function showPalettePart(partName, animate) {
            let partPanel = $(".palette > ul"), partsWidth = partPanel.width();
            partPanel.toggleClass("scrollMode");
            if (animate) {
                partPanel.animate({scrollLeft: partPanel.find(`.part-${partName}`).index() * (partsWidth)}, 300, function() {
                    partPanel.toggleClass("scrollMode");
                    //paletteScroll();
                    //checkLastPartLogic();
                });
            } else {
                partPanel.scrollLeft(partPanel.find(`.part-${partName}`).index() * (partsWidth) );
                partPanel.toggleClass("scrollMode");
                //paletteScroll();
                //checkLastPartLogic();
            }
        }

        function loadPartMap() {
            $(".dsPartMap").each(function () {
                let svgSRC = $(this).data("src"), animate = true, partName;
                $(this).load(svgSRC, function (responseText, textStatus, XMLHttpRequest) {
                    if (textStatus === "success") {
                        $(".dsPartMap svg path ").off("click").on("click", function () {
                            $("#cwDesignStudio").removeClass("allPartsMode");
                            partName = $(this).data("name")
                            if (partName === undefined) {
                                 partName = $(this).attr("id")
                            }
                            showPalettePart(partName, animate);
                        });
                    } else {
                        $(this).empty();
                    }                   
                });
            });           
        }


        function updateDesignURL() {
            const state = {
                baseModel: '', // We'll set this from cwColors
                colors: {},
                engravings: {}
            };

            // Get base model from VariantSEName and cwColors
            const variantSEName = $('#VariantSEName').val();
            if (variantSEName && cwColors[variantSEName]) {
                state.baseModel = cwColors[variantSEName].partnumber;
            }

            // Collect color selections
            $('.js-kit-group').each(function() {
                const partSEName = $(this).data('part-sename');
                const select = $(this).find('.partColorOptions');
                if (select.length) {
                    const selectedOption = select.find('option:selected');
                    if (selectedOption.length && selectedOption.data('sename')) {
                        state.colors[partSEName] = selectedOption.data('sename');
                    }
                }
            });

            // Collect engraving data
            $('.engraving-option').each(function() {
                const groupName = $(this).data('part-sename');
                const engravingData = {};
                
                $(this).find('textarea').each(function() {
                    const fieldName = $(this).data('self-sename');
                    const value = $(this).val();
                    if (fieldName && !fieldName.startsWith('imageangle') && value) {
                        engravingData[fieldName] = value;
                    }
                });

                if (Object.keys(engravingData).length > 0) {
                    state.engravings[groupName] = engravingData;
                }
            });

            // Update URL without reloading page
            const encodedState = btoa(encodeURIComponent(JSON.stringify(state)));
            const url = new URL(window.location.href);
            url.searchParams.set('design', encodedState);
            window.history.replaceState({}, '', url.toString());
        }

        function loadDesignFromURL() {
            const designParam = getRequestValue('design');
            
            if (!designParam) {
                // If no design parameter, create initial URL state
                updateDesignURL();
                return;
            }

            try {
                const state = JSON.parse(decodeURIComponent(atob(designParam)));

                // Apply base model if it exists
                if (state.baseModel) {
                    // Find the variant SEName by partnumber
                    for (const [seName, data] of Object.entries(cwColors)) {
                        if (data.partnumber === state.baseModel) {
                            $('#VariantSEName').val(seName).trigger('change');
                            // Update model-partnumber
                            const basePartNumber = $('#model-partnumber').data('basepartnumber');
                            const newPartNumber = basePartNumber.replace('[]', state.baseModel);
                            $('#model-partnumber').val(newPartNumber);
                            break;
                        }
                    }
                }

                // Apply colors
                for (const [partSEName, colorSEName] of Object.entries(state.colors)) {
                    const select = $(`.js-kit-group[data-part-sename="${partSEName}"] .partColorOptions`);
                    if (select.length) {
                        const option = select.find(`option[data-sename="${colorSEName}"]`);
                        if (option.length) {
                            select.val(option.val()).trigger('change');
                        }
                    }
                }

                // Apply engravings
                for (const [groupName, engravingData] of Object.entries(state.engravings)) {
                    for (const [fieldName, value] of Object.entries(engravingData)) {
                        $(`.engraving-option[data-part-sename="${groupName}"] textarea[data-self-sename="${fieldName}"]`)
                            .val(value)
                            .trigger('propertychange');
                    }
                }
                updateDesignURL();

            } catch (error) {
                console.error('Error loading design state:', error);
            }
        }

        function fixDSImgSize(imgSrc, newSize) {
            let newImgSize, windowWidth = cwDS.cwWindow.width();
            
            if (newSize === 0) {
                newImgSize = 2560;
                if (windowWidth < 2010) { newImgSize = 2000; }
                if (windowWidth < 1010) { newImgSize = 1000; }
                if (windowWidth < 650) { newImgSize = 640; }
                if (windowWidth < 510) { newImgSize = 500; }
                if (windowWidth < 330) { newImgSize = 320; }
                if (windowWidth < 110) { newImgSize = 100; }
                if (window.devicePixelRatio > 1.5) {
                    if (newImgSize === 2000) { newImgSize = 2560; }
                    if (newImgSize === 1000) { newImgSize = 2000; }
                    if (newImgSize === 640) { newImgSize = 1000; }
                    if (newImgSize === 500) { newImgSize = 1000; }
                    if (newImgSize === 320) { newImgSize = 640; }
                    if (newImgSize === 100) { newImgSize = 320; }
                }

                if (cwDS.imageFormat === 'webp') {
                    newImgSize = windowWidth >= 1010 ? 2560 : 1000;  // Use 2560 for desktop and 1000 for mobile
                }

            } else {
                newImgSize = newSize;
            }
            if (newImgSize > cwDS.maxProductSize) {
                newImgSize = cwDS.maxProductSize;
            }


            //newImgSize = 2000;

            if (typeof imgSrc === 'undefined') { return imgSrc; } 
            imgSrc = imgSrc.replace("size-2560", "size-xxx").replace("size-2000", "size-xxx").replace("size-1000", "size-xxx").replace("size-320", "size-xxx");
            imgSrc = imgSrc.replace("size-500", "size-xxx").replace("size-640", "size-xxx").replace("size-100", "size-xxx").replace("size-xxx", `size-${newImgSize}`);
            return imgSrc;
        }

        function getLines(ctx, text, maxWidth) {
            let words = text.split(" "), lines = [], currentLine = words[0];        
            for (let i = 1; i < words.length; i++) {
                let word = words[i], width = ctx.measureText(currentLine + " " + word).width;
                if (width < maxWidth) {
                    currentLine += " " + word;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        }
        
        function fillEngravingText(angle, engData) {
            let lines, imageAngle, groupName, xstart, ystart, maxWidth, fontSize, lineCount, textAlign, lineheight, engContext, engSmallContext, imagesizeW, imagesizeH, finalLines = [], imageSizeRatio;
            

            groupName = engData.group;

            if (cwEngravingColors[engData.textcolor] === undefined) { return false; }
            //remove emojis
            engData.text = engData.text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F251}\u{1F600}-\u{1F636}\u{1F645}-\u{1F64F}\u{1F300}-\u{1F641}\u{1F3E0}-\u{1F3F0}\u{25AA}\u{25AB}\u{25FE}\u{25FD}\u{25FB}\u{25FC}\u{2B1B}\u{2B1C}\u{25B6}\u{25C0}\u{1F200}-\u{1F251}\u{0F00}-\u{0FFF}\u{1D400}-\u{1D7FF}]/gu, '');


            lines = engData.text.split('\n');
            imagesizeW = "2560";
            //imagesizeW = fixDSImgSize(imagesizeW, 0).replace("size-", "");
            imagesizeW = parseInt(imagesizeW, 10);


            imageSizeRatio = imagesizeW / 2560;


            imagesizeH = imagesizeW*0.6;


            xstart = imagesizeW*parseFloat($(`.partdata-xstart.part-${groupName}`).data("description"), 10);
            ystart = imagesizeH*parseFloat($(`.partdata-ystart.part-${groupName}`).data("description"), 10);
            maxWidth = imagesizeH*parseFloat($(`.partdata-maxwidth.part-${groupName}`).data("description"), 10);
            fontSize = imagesizeH*parseFloat($(`.partdata-fontsize.part-${groupName}`).data("description"), 10);
            lineCount = parseInt($(`.partdata-linecount.part-${groupName}`).data("description"), 10);
            imageAngle = $(`.partdata-imageangle${angle}.part-${groupName}`).data("description");
            textAlign = "center";
            if (typeof $(`.partdata-textalign.part-${groupName}`).data("description") !== 'undefined') {
                textAlign = $(`.partdata-textalign.part-${groupName}`).data("description"); 
            }                               
            lineheight = fontSize*1.3;
            engContext = document.createElement("canvas").getContext('2d');
            engContext.canvas.width = imagesizeW;
            engContext.canvas.height = imagesizeH;                
            engContext.textBaseline = "middle";
            engContext.textAlign = textAlign;

            engContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engContext.fillStyle = cwEngravingColors[engData.textcolor].fontcolor;

            engSmallContext = document.createElement("canvas").getContext('2d');
            engSmallContext.canvas.width = maxWidth;
            engSmallContext.canvas.height = lineheight*lineCount;                
            engSmallContext.textBaseline = "middle";
            engSmallContext.textAlign = textAlign;
            engSmallContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engSmallContext.fillStyle = "#000000";
          
            //cwEngravingColors
            if (imageAngle !== "") {
                let imageAngleData, xScale, ySkew, xSkew, yScale, xMove, yMove;
                imageAngleData = imageAngle.split(",");
                xScale = imageAngleData[0];
                xSkew = imageAngleData[2];
                xMove = imageAngleData[4];
                yScale = imageAngleData[3];
                ySkew = imageAngleData[1];
                yMove = imageAngleData[5];


                xMove = xMove * imageSizeRatio;
                yMove = yMove * imageSizeRatio;

                
                engContext.setTransform(xScale, ySkew, xSkew, yScale, xMove, yMove);
            }
            
            for (let i = 0; i < lines.length; i++) { // Chat GTP optimization
                let tempLines = getLines(engContext, lines[i], maxWidth), extralines = 0;
                for (let j = 0; j < tempLines.length; j++) {

                    while (engContext.measureText(tempLines[j]).width > maxWidth) {
                        tempLines[j] = tempLines[j].substring(0, tempLines[j].length - 1);
                    }

                    if (finalLines.length < lineCount) {
                        engContext.fillText(tempLines[j], xstart, ystart + ((i + extralines) * lineheight));
                        engSmallContext.fillText(tempLines[j], maxWidth/2, (lineheight/2) + ((i + extralines) * lineheight));
                        finalLines.push(tempLines[j]);
                    }
                    extralines++;
                }
            }

            $(`.engTextArea-${groupName}`).prop("value", finalLines.join('\n'));
            $(`#engraving-text-${groupName}`).val(finalLines.join('\n'));



            if (imageAngle === "hide") { 
                engContext.clearRect(0, 0, engContext.canvas.width, engContext.canvas.height); 
            } else if (imageAngle === "") {
                let imageDataURL = engSmallContext.canvas.toDataURL();
                let base64Image = imageDataURL.split(',')[1];
                engravingImages[`.partdata-imageangle${angle}`] = base64Image;
                //$(`.partdata-imageangle${angle}`).prop("value", base64Image);
                //$(`.tmpImgHolder`).attr("src", imageDataURL);                
            }

            return engContext.canvas.toDataURL();
        }

        function createCanvasImageOLD(dsImages, angle, imageToUpdate) {
            let dsMainContext, imagesize, tempImageCount, cwAngleImage, tempImages, dsBGContext;
            
            dsMainContext = document.createElement("canvas").getContext('2d');
            imagesize = "size-2560";
            tempImageCount = 0;
            //cwAngleImage = document.getElementById(`dsAngle${angle}Img`);
            cwAngleImage = document.getElementById(imageToUpdate);

            if(cwAngleImage !== null) {                    
                cwAngleImage.onload = function() {
                    //if (angle === 1) {
                    if (imageToUpdate === 'dsAngle1Img') {
                        addBrainstorm($("#dsAngle1Img"), $("#formSaveDesignURL").val());
                    }
                };
            }
            tempImages = [];
            imagesize = fixDSImgSize(imagesize, 0).replace("size-", "");
            dsMainContext.canvas.width = parseInt(imagesize, 10);
            dsMainContext.canvas.height = (parseInt(imagesize, 10) * 0.6);
            dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
            dsMainContext.fillStyle = "#FFF";
            $(dsImages).each(function () {                        
                let tempImage = new Image(), cartImageDataURL, cartBase64Image;
                tempImage.onload = ()=>{ 
                    let tmpCanvas = document.createElement('canvas');
                    let tmpCtx = tmpCanvas.getContext('2d');
                    let targetWidth = 700;
                    let targetHeight = tempImage.height * (700 / tempImage.width);
                    tmpCanvas.width = targetWidth;
                    tmpCanvas.height = targetHeight;


                    tempImageCount += 1;
                    if(tempImageCount === tempImages.length){ // have all loaded????                                
                        for (let j = 0; j<tempImages.length; j++) {
                            dsMainContext.drawImage(tempImages[j],0,0);
                            tmpCtx.drawImage(tempImages[j], 0, 0, targetWidth, targetHeight);
                        } 
                        let resizedDataURL = tmpCanvas.toDataURL('image/webp', 0.7);
                        let resizedcartBase64Image = resizedDataURL.split(',')[1];

                        if(cwAngleImage !== null) { 
                            cwAngleImage.src = dsMainContext.canvas.toDataURL("image/webp");
                            cartImageDataURL = dsMainContext.canvas.toDataURL("image/webp");
                            cartBase64Image = cartImageDataURL.split(',')[1];
                            cartImages[`.cart-image-angle-${angle}`] = resizedcartBase64Image;
                        }
                    }
                }
                tempImage.crossOrigin = 'Anonymous';
                if (this.type === canvasImageType.image) {
                    if (this.url !== undefined) {
                        tempImage.src = fixDSImgSize(this.url, imagesize);
                    }      
                } else if (this.type === canvasImageType.engraving) {
                    let engravingImage = fillEngravingText(angle, this);
                        tempImage.src = engravingImage;

                }
                tempImages.push(tempImage); // add loading image to images array      
            });
        }


        function clearAllCanvasImages() {
            // Clear all main DS images
            /*
            $(".studio img").each(function() {
                const emptyCanvas = document.createElement("canvas");
                const ctx = emptyCanvas.getContext('2d');
                emptyCanvas.width = this.width || 700;
                emptyCanvas.height = this.height || 420; // 700 * 0.6
                
                // Fill with white
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, emptyCanvas.width, emptyCanvas.height);
                
                this.src = emptyCanvas.toDataURL("image/webp");
            });

            // Clear all variant swatches
            $(".variantSwatch img").each(function() {
                const emptyCanvas = document.createElement("canvas");
                const ctx = emptyCanvas.getContext('2d');
                emptyCanvas.width = this.width || 100;  // smaller for swatches
                emptyCanvas.height = this.height || 60;
                
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, emptyCanvas.width, emptyCanvas.height);
                
                this.src = emptyCanvas.toDataURL("image/webp");
            });
            */
            // Clear cart images array

            for (const key in cartImages) {
                if (cartImages.hasOwnProperty(key)) {
                    delete cartImages[key];
                }
            }

            // Clear engraving images array
            for (const key in engravingImages) {
                if (engravingImages.hasOwnProperty(key)) {
                    delete engravingImages[key];
                }
            }
        }
        function createCanvasImage(dsImages, angle, imageToUpdate, imagesize) {
            let dsMainContext, tempImageCount, cwAngleImage, tempImages, dsBGContext;
            const isVariantSwatch = imageToUpdate.startsWith('variant-swatch-');
    
            if (currentRenderController) {
                currentRenderController.abort();
                //clearAllCanvasImages(); // Clear everything when aborting
            } else {
                // Also clear everything when starting a new render sequence
                //clearAllCanvasImages();
            }
            
            currentRenderController = new AbortController();
            const signal = currentRenderController.signal;

            dsMainContext = document.createElement("canvas").getContext('2d');
            //imagesize = "size-2560";
            tempImageCount = 0;
            cwAngleImage = document.getElementById(imageToUpdate);
        
            if (cwAngleImage !== null) {                    
                cwAngleImage.onload = function() {
                    if (imageToUpdate === 'dsAngle1Img') {
                        addBrainstorm($("#dsAngle1Img"), $("#formSaveDesignURL").val());
                    }
                };
            }
            tempImages = [];
            imagesize = fixDSImgSize("size-2560", imagesize).replace("size-", "");
            dsMainContext.canvas.width = parseInt(imagesize, 10);
            dsMainContext.canvas.height = (parseInt(imagesize, 10) * 0.6);
            dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
            dsMainContext.fillStyle = "#FFF";
        
            let loadImagePromises = [];
        
            $(dsImages).each(function () {                        
                if (this.type === canvasImageType.image) {
                    loadImagePromises.push(new Promise(resolve => {
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = fixDSImgSize(this.url, imagesize);
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                } else if (this.type === canvasImageType.engraving) {
                    loadImagePromises.push(new Promise(resolve => {
                        let engravingDataURL = fillEngravingText(angle, this);
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = engravingDataURL;
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                }
            });
            /* START original before optimization tweaks
            Promise.all(loadImagePromises).then(images => {
                images.forEach(image => {
                    dsMainContext.drawImage(image, 0, 0);
                });
                if (cwAngleImage !== null) {
                    cwAngleImage.src = dsMainContext.canvas.toDataURL("image/webp");
                }

                let tmpCanvas = document.createElement('canvas');
                let tmpCtx = tmpCanvas.getContext('2d');
                let targetWidth = 700;
                let targetHeight = images[0].height * (targetWidth / images[0].width);

                tmpCanvas.width = targetWidth;
                tmpCanvas.height = targetHeight;

                images.forEach(image => {
                    //tmpCtx.clearRect(0, 0, targetWidth, targetHeight);
                    tmpCtx.drawImage(image, 0, 0, targetWidth, targetHeight);
                });
                //let resizedDataURL = tmpCanvas.toDataURL('image/webp', 0.7); // Compress at 70% quality
                let resizedDataURL = tmpCanvas.toDataURL('image/png', 0.35); // Compress at 70% quality  TEST FOR SAFARI
                cartImages[`.cart-image-angle-${angle}`] = resizedDataURL;//.split(',')[1]; including the image type for now
            });
            END original before optimization tweaks */

            Promise.all(loadImagePromises).then(images => {
                /*
                if (signal.aborted) {
                    throw new Error('Render aborted');
                }
                */
                const layerInfo = dsImages.map((img, index) => ({
                    type: img.type,
                    layer: index,
                    isBackground: img.url?.includes('/bg.'),
                    isModel: img.url?.includes('/model/') && !img.url?.includes('/bg.') && !img.url?.includes('/fg.'),
                    isForeground: img.url?.includes('/fg.'),
                    url: img.url,
                    isEngraving: img.type === canvasImageType.engraving
                }));
                
                dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
                dsMainContext.fillStyle = "#FFFFFF";
                dsMainContext.fillRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
            
                images.forEach(image => {
                    dsMainContext.drawImage(image, 0, 0);
                });
                if (cwAngleImage !== null) {
                    cwAngleImage.src = dsMainContext.canvas.toDataURL("image/webp");
                }


                if (!isVariantSwatch) {
                    let tmpCanvas = document.createElement('canvas');
                    let tmpCtx = tmpCanvas.getContext('2d');
                    let targetWidth = 700;
                    let targetHeight = images[0].height * (targetWidth / images[0].width);
        
                    tmpCanvas.width = targetWidth;
                    tmpCanvas.height = targetHeight;
        
                    tmpCtx.fillStyle = "#FFFFFF";
                    tmpCtx.fillRect(0, 0, targetWidth, targetHeight);
        
                    images.forEach(image => {
                        tmpCtx.drawImage(image, 0, 0, targetWidth, targetHeight);
                    });
        
                    // Compress cart image
                    function getCompressedDataURL(canvas, quality) {
                        return canvas.toDataURL('image/jpeg', quality);
                    }
        
                    let quality = 1;
                    let resizedDataURL = getCompressedDataURL(tmpCanvas, quality);
        
                    while (resizedDataURL.length / 1024 > 95 && quality > 0.1) {
                        /*
                        if (signal.aborted) {
                            throw new Error('Render aborted');
                        }
                            */
                        quality -= 0.1;
                        resizedDataURL = getCompressedDataURL(tmpCanvas, quality);
                    }
        
                    cartImages[`.cart-image-angle-${angle}`] = resizedDataURL;
                
                }
    /*
                let tmpCanvas = document.createElement('canvas');
                let tmpCtx = tmpCanvas.getContext('2d');
                let targetWidth = 700;
                let targetHeight = images[0].height * (targetWidth / images[0].width);

                tmpCanvas.width = targetWidth;
                tmpCanvas.height = targetHeight;

                tmpCtx.fillStyle = "#FFFFFF"; // Set the fill color to white
                tmpCtx.fillRect(0, 0, targetWidth, targetHeight); // Draw a white rectangle covering the whole canvas

                images.forEach(image => {
                    //tmpCtx.clearRect(0, 0, targetWidth, targetHeight);
                    //tmpCtx.clearRect(0, 0, targetWidth, targetHeight);
                    tmpCtx.drawImage(image, 0, 0, targetWidth, targetHeight);
                });
                //let resizedDataURL = tmpCanvas.toDataURL('image/webp', 0.7); // Compress at 70% quality
                //let resizedDataURL = tmpCanvas.toDataURL('image/jpeg', 0.3); // Compress at 70% quality  TEST FOR SAFARI


                
                // Function to compress and check the image size
                function getCompressedDataURL(canvas, quality) {
                    return canvas.toDataURL('image/jpeg', quality);
                }

                // Start at high quality and reduce if needed
                let quality = 1;
                let resizedDataURL = getCompressedDataURL(tmpCanvas, quality);

                // Check if the data URL exceeds the size limit (95 KB)
                while (resizedDataURL.length / 1024 > 95 && quality > 0.1) {
                    quality -= 0.1; // Reduce quality in steps of 0.2
                    resizedDataURL = getCompressedDataURL(tmpCanvas, quality);
                }
                
                //let resizedDataURL = canvas.toDataURL('image/png');
                cartImages[`.cart-image-angle-${angle}`] = resizedDataURL;//.split(',')[1]; including the image type for now
           */ }).catch(error => {
            if (error.message === 'Render aborted') {
                console.log(`Render for angle ${angle} was aborted for newer render`);
            } else {
                console.error('Error in canvas render:', error);
            }
        })
        .finally(() => {
            // Clear controller reference if this is the current render
            if (currentRenderController && currentRenderController.signal === signal) {
                currentRenderController = null;
            }
        });;
        }
        
        
        function drawDSImages(angle, imageToUpdate, variantID, imageSize) {
            let dsImages = [];
            dsImages.push({type:canvasImageType.image, url:`${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/bg.${cwDS.imageFormat}`});
            //$(`.variantSwatch[data-variant-id='${variantID}']`).each( function () {            
            $(`.variantSwatch.variant-${variantID}`).each( function () {
                let variantSEName = $(this).data("variant-sename");
                if (variantSEName.indexOf("$") < 0) {
                    dsImages.push({type:canvasImageType.image, url:`${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/${variantSEName}.${cwDS.imageFormat}`});
                }
            });

            $(".js-kit-group").each(function () {
                $(this).find(".partColorOptions").each(function () {
                    let groupName = $(this).data("group-name");
                    $(this).children(":selected").each(function () {
                        let colorName = $(this).data("sename"), colorObj, ignoreColor, partColorLookup = colorName;
                        if ($(this).data("finish") === "skin") { partColorLookup = `${colorName}-skin`; }
                        if ($(this).data("finish") === "style") { partColorLookup = `${colorName}-style`; }
                        colorObj = cwColors[partColorLookup];
                        ignoreColor = (colorObj.offoption) ? true : false;
                        if ($(this).data("finish") === "show") { ignoreColor = false }
                        if (!ignoreColor) {
                            dsImages.push({type:canvasImageType.image, url:`${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/${groupName}/size-2560/${colorName}.${cwDS.imageFormat}`});
                        }
                    });
                });
                $(this).find(".textarea-group textarea").each(function () {                  
                    let groupName = $(this).data("group-name");
                    let selfName = $(this).data("self-sename");                  
                    if ($(this).prop("value") !== "" && selfName && !selfName.startsWith("imageangle")) {
                        dsImages.push({type:canvasImageType.engraving, text:$(this).prop("value"), group:groupName, textcolor:selfName});
                    }
                });               
            });
            dsImages.push({type:canvasImageType.image, url:`${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/fg.${cwDS.imageFormat}`});
            createCanvasImage(dsImages, angle, imageToUpdate, imageSize);                   
        }

        function updatePartNumbers() {
            $(`.select.kit-group`).each(function () {
                let partSEName = $(this).data("part-sename"), partColorLookup;
                $(this).find(`.partColorOptions`).children(":selected").each(function () {
                    partColorLookup = $(this).data("sename");
                    if ($(this).data("finish") === "skin") { partColorLookup = `${partColorLookup}-skin` }
                    if ($(this).data("finish") === "style") { partColorLookup = `${partColorLookup}-style` }
                    $(`#${partSEName}-partnumber`).val($(`select.part-${partSEName}`).data("part-number") + "-" + cwColors[partColorLookup].partnumber);
                });
            });

            $(`#VariantSEName`).each(function () { //Shopify logic
                let curModel = $(this).prop("value");
                let curModelPartNumber = cwColors[curModel].partnumber;
                let modelBasePartNumber = $("#model-partnumber").data("basepartnumber"), fullPartNumber;                
                fullPartNumber = modelBasePartNumber.replace("[]", curModelPartNumber);
                curModel = $("#model-partnumber").prop("value", fullPartNumber);
            });
        }

        function drawAllDSImages() {


            if (currentRenderController) {
                currentRenderController.abort();
                //clearAllCanvasImages();
            }

            let anglesArray = [], imageToUpdate;            
            $(".kit-group").each(function () {
                let groupAngle = $(this).data("angle");
                if (groupAngle !== undefined && anglesArray.indexOf(groupAngle) === -1 && groupAngle !== "") {
                    anglesArray.push(groupAngle);
                }
            });
            
            if (anglesArray.length === 0) {
                anglesArray.push(1);
            }

            $(anglesArray).each(function () {
                let variantID = 0;
                /*
                $("#VariantID").each(function () {
                    variantID = $(this).prop("value");
                });
                */
                //$(`input[name="VariantSEName"]`).each(function () {
                $(`#VariantSEName`).each(function () {
                    variantID = $(this).prop("value");
                    variantID = variantID.replace("$", "");
                });

                imageToUpdate = `dsAngle${this}Img`;
                drawDSImages(this, imageToUpdate, variantID, 2560);
            });

            $(".variantSwatch").each(function () { //ASPDOTNET Storefront logic
                let variantID = $(this).data("variant-id");                
                //drawDSImages(1, `variant-swatch-${variantID}`, variantID);
            });
          
            $(".variantSwatch").each(function () { //Shopify logic
                let variantSEName = $(this).data("variant-sename");
                variantSEName = variantSEName.replace("$", "");
                drawDSImages(1, `variant-swatch-${variantSEName}`, variantSEName, 1000);
            });
            



            updatePartNumbers();

            //addBrainstorm($("#dsAngle1Img"), $("#formSaveDesignURL").val());

        }            

        function addBrainstorm(imgSrc, colors) {
            let bsUl, bsLi, bsImg;
            bsUl = $(".brainstorm ul");
            bsLi = document.createElement("li");
            bsImg = document.createElement("img");
            bsImg.src = imgSrc.attr("src");

            bsImg.dataset.url = colors;    
            bsLi.append(bsImg);
            bsLi.className = "mediaLoadDesign";


            if (imgSrc.attr("src") !== undefined) {


                // Count the current li elements excluding .addDesign button
                let currentLiCount = bsUl.find("li:not(.addDesign)").length;


                // If there are 4 or more li elements, remove the first one
                if (currentLiCount >= 4) {
                    bsUl.find("li:not(.addDesign):first").remove();
                }
                bsUl.append(bsLi);

            }
            
            $(".mediaLoadDesign").off("click").on("click",  applyGalleryColors );
        }


        function updateSelectedColorsPalette() {
            let palette = $(".palette"), partList = $(".kit-group"), urlToPushHistory, partsURL = "", partFilesUrl = "";
/*
            $(`input[name="VariantId"]`).each(function () { //ASPDOTNET Storefront logic
                let selectedColor, partName = "Model", selectedColorSE, variantId, partSEName = "variant";
                variantId = $(this).prop("value");
                selectedColor = $(`.variantSwatch[data-variant-id='${variantId}']`).prop("title");
                selectedColorSE = $(`.variantSwatch[data-variant-id='${variantId}']`).data("variant-sename");
                if (selectedColorSE !== undefined ) {
                    selectedColorSE = selectedColorSE.replace("$", "");
                }
                palette.find(`.part-${partSEName} h4 .partName`).html(`${partName}: `);
                palette.find(`.part-${partSEName} h4 .colorName`).html(selectedColor);
                palette.find(`.part-${partSEName} h4 div`).attr('class', ` colorSwatch color${selectedColorSE} `);
                palette.find(`.part-${partSEName} .part-options .variantSwatch`).removeClass("isSelected");
                palette.find(".part-"+ partSEName + "  .part-options .variant-" + selectedColorSE + ".variantSwatch").addClass("isSelected");
                if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                if (selectedColorSE !== undefined) {
                    partFilesUrl = `${partFilesUrl}model/${selectedColorSE}`;
                }
            });
*/
            $(`#VariantSEName`).each(function () { //Shopify logic
                let selectedColor, partName = "Model", selectedColorSE, variantSEName, partSEName = "variant";                
                variantSEName = $(this).prop("value");
                if (variantSEName !== undefined ) {
                    variantSEName = variantSEName.replace("$", "");
                }  
                selectedColor = $(`.variantSwatch.variant-${variantSEName}`).prop("title");
                selectedColorSE = $(`.variantSwatch.variant-${variantSEName}`).data("variant-sename");
                if (selectedColorSE !== undefined ) {
                    selectedColorSE = selectedColorSE.replace("$", "");
                }  
                palette.find(`.part-${partSEName} h4 .partName`).html(`${partName}: `);
                palette.find(`.part-${partSEName} h4 .colorName`).html(selectedColor);
                palette.find(`.part-${partSEName} h4 div`).attr('class', ` colorSwatch color${selectedColorSE} `);
                palette.find(`.part-${partSEName} .part-options .variantSwatch`).removeClass("isSelected");
                palette.find(".part-"+ partSEName + "  .part-options .variant-" + selectedColorSE + ".variantSwatch").addClass("isSelected");
                let varRadioButton = $(`input[name="Style"][value="$${selectedColorSE}"]`);
                
                if (varRadioButton.length > 0) {
                    varRadioButton.prop('checked', true);

                    try {
                        let event = new Event('change', { bubbles: true });
                        varRadioButton[0].dispatchEvent(event);
                    } catch (error) {
                        console.error('Error dispatching change event or calling onVariantChange:', error);
                    }
                }
                

                if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                if (selectedColorSE !== undefined) {
                    partFilesUrl = `${partFilesUrl}model/${selectedColorSE}`;
                }
            });


            partList.each(function () {
                let part, partSelect, partName, partSEName, partGroupId, partItemId, textAreas, partPrice = 0;
                part = $(this);
                partSelect = part.find(".partColorOptions");
                partName = part.data("part-name");
                partSEName = part.data("part-sename");
                partGroupId = parseInt(part.data("group-id"));
                textAreas = part.find(".partTextOptions");

                partSelect.children(":selected").each(function () {
                    let selectedColor = $(this).data("name"), selectedColorSE = $(this).data("sename"), curlocation, colorObj, ignoreColor, partColorLookup = selectedColorSE, upchargeCheckbox;
                    palette.find(`.part-${partSEName} h4 .partName`).html(`${partName}: `);
                    palette.find(`.part-${partSEName} h4 .colorName`).html(selectedColor);
                    palette.find(`.part-${partSEName} h4 div`).attr('class', ` colorSwatch color${selectedColorSE} `);
                    palette.find(`.part-${partSEName} h4 div`).html(` `);
                    palette.find(`.part-${partSEName} .part-options .colorSwatch`).removeClass("isSelected");
                    palette.find(`.part-${partSEName} .part-options .color${selectedColorSE}.colorSwatch`).addClass("isSelected");
                    palette.find(`.part-${partSEName} `).removeClass("offOptionSelected");
                    
                    if ($(this).data("finish") === "skin") { partColorLookup = `${selectedColorSE}-skin` }
                    if ($(this).data("finish") === "style") { partColorLookup = `${selectedColorSE}-style` }
                    colorObj = cwColors[partColorLookup];
                    ignoreColor = (colorObj.offoption) ? true : false;
                    upchargeCheckbox = $('.js-upcharge-checkbox[data-part-name="' + partName + '"]');                    
                    if (upchargeCheckbox.length) {
                        if (!ignoreColor) {
                            partPrice = parseInt(upchargeCheckbox.val(), 10);//.data("price");
                        }

                        if ((ignoreColor && upchargeCheckbox.prop('checked')) || (!ignoreColor && !upchargeCheckbox.prop('checked'))) {
                            upchargeCheckbox.trigger("click");
                        }


                    }
                    if (partPrice > 0) {
                        palette.find(`.part-${partSEName} h4 .productPartPrice`).html(`$${partPrice}`);
                    } else {
                        palette.find(`.part-${partSEName} h4 .productPartPrice`).html(``);
                    }

                    if ($(this).data("finish") === "show") { ignoreColor = false }
                    if (!ignoreColor) {                     
                        if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                        partFilesUrl = `${partFilesUrl}${partSEName}/${selectedColorSE}`;
                        //curlocation
                    } else {
                        palette.find(`.part-${partSEName} `).addClass("offOptionSelected");
                    }
                });
                textAreas.each(function () {
                    let selectedColor = "None", selectedColorSE = "none", objTextArea, textPriceDelta = 0, colorObj, partColorLookup, ignoreColor, upchargeCheckbox;                    
                    palette.find(`.part-${partSEName} `).addClass("offOptionSelected");
                    upchargeCheckbox = $('.js-upcharge-checkbox[data-part-name="' + partName + '"]');
                    if (upchargeCheckbox.prop('checked')) {
                        upchargeCheckbox.trigger("click");
                    }
                    $(`.kit-text-area.part-${partSEName}`).each(function () { 
                        objTextArea = $(this);
                        if (objTextArea.val() !== "" && !objTextArea.data("self-sename").toLowerCase().startsWith("imageangle")) {
                            selectedColor = objTextArea.data("self-name");
                            selectedColorSE =  objTextArea.data("self-sename");
                            partColorLookup = selectedColorSE;
                            colorObj = cwColors[partColorLookup];
                            ignoreColor = (colorObj.offoption) ? true : false;

                            if (upchargeCheckbox.length) {
                                if ((ignoreColor && upchargeCheckbox.prop('checked')) || (!ignoreColor && !upchargeCheckbox.prop('checked'))) {
                                    upchargeCheckbox.trigger("click");
                                }
                                if (!ignoreColor) {
                                    textPriceDelta = parseInt(upchargeCheckbox.val(), 10);//.data("price");
                                }
                            }
                            palette.find(`.part-${partSEName} `).removeClass("offOptionSelected");
                        } 
                    });
                    palette.find(`.part-${partSEName} h4 .partName`).html(`${partName}: `);
                    palette.find(`.part-${partSEName} h4 .colorName`).html(selectedColor);
                    palette.find(`.part-${partSEName} h4 .productPartPrice`).html(`$${textPriceDelta}`);
                    palette.find(`.part-${partSEName} h4 div`).attr('class', ` colorSwatch color${selectedColorSE} `);

                    toggleMustPaintMessage(partSEName);
                });

            });
            $("#partFilesUrl").prop("value", partFilesUrl);
            $("#formPartsURL").prop("value", partFilesUrl);            
            $("#formDSPartsVersion").prop("value", cwDS.productPartsVersion);
            $("#formDSVersion").prop("value", cwDS.dsVersion);
            let requiredSKUs = [];          
            $(`.kit-group`).each( function () {
              const isOptional = $(this).data('optional') === true;
              const skuNeeded = $(this).data('sku-needed');
              if (isOptional) {
                // Check if there is a select list in this group
                const selectList = $(this).find('select');
                if (selectList.length > 0) {
                  // Get the selected option
                  const selectedOptionSEName = selectList.find('option:selected').data('sename');
                  const partName = $(this).data('part-name');
                  const selectedValue = selectList.val();      
                  const colorObj = cwColors[selectedOptionSEName];
                  let isOffOption = false;
                  if (colorObj && colorObj.offoption === 'true') {
                    isOffOption = true;
                  }                  
                  if (!isOffOption && skuNeeded) {
                    requiredSKUs.push(skuNeeded);
                  }
                }                
                // Handle text areas
                const textAreas = $(this).find('textarea[data-self-sename$="-text"]');
                let nonEmptyTextAreaFound = false;
                textAreas.each(function () {
                    if ($(this).val().trim() !== '') {
                        nonEmptyTextAreaFound = true;
                        return false; // Break out of the .each loop
                    }
                });        
                if (nonEmptyTextAreaFound) {
                    requiredSKUs.push(skuNeeded);
                }                
              }
            });          
            updateProductPrice();
        }

        function colorSwatchSelected() {
            let partSEName = $(this).parent().data("partsename");
            $(`select.part-${partSEName}`).val($(this).data("value")).trigger("change");

            //$(`#${partSEName}-partnumber`).val($(`select.part-${partSEName}`).data("part-number") + "-" + cwColors[$(this).data("value").toLowerCase().replace(" ", "-")].partnumber);


            $(`textarea.paletteEngArea[data-parentsename='${partSEName}']`).each( function () {
                //updateTextAreas(this);
                debouncedUpdateTextAreas(this);
            });
            updateSelectedColorsPalette();
        }

        function partTextChanged(textElement) {
            let textJQ = $(textElement), parentPart, parentPartColor, colorObj, partName;
            partName = textJQ.data("partsename");
            parentPart = textJQ.data("parentsename");            
            $(`.partColorOptions.part-${parentPart}`).children(":selected").each(function () {
                parentPartColor = $(this).data("sename");
            });
            textJQ.html(textJQ.val());
            colorObj = cwColors[parentPartColor];
            if (textJQ.val() === '') {
                for (const prop in engravingImages) {
                    if (engravingImages.hasOwnProperty(prop)) {
                        delete engravingImages[prop];
                    }
                }
            }
            if (colorObj !== undefined) {
                $(`.part-${partName}`).val("");

              
                $(`.part-${partName}.partdata-${colorObj.engravingtext}`).val(textJQ.val());
                //colorArray.push( { category: colorObj.category, displayorder: colorObj.displayorder, sename: partColor, name: partName, value: $(this).val()} );
            }

            if (textJQ.val() === '') {
                $(`#engraving-price-${partName}`).prop("value", "");
                $(`#engraving-text-${partName}`).val("");
                $(`#engraving-part-number-${partName}`).prop("value", "");
                $(`#engraving-color-${partName}`).prop("value", "");

            } else {
                $(`#engraving-price-${partName}`).prop("value",  $(`#${partName}-upcharge`).prop("value"));
                $(`#engraving-text-${partName}`).val(textJQ.val());
                $(`#engraving-part-number-${partName}`).prop("value", `${$(`#engraving-part-number-${partName}`).data("base-part-number")}-${cwColors[colorObj.engravingtext].partnumber}`);
                $(`#engraving-color-${partName}`).prop("value", colorObj.engravingtext);
            }
            /*

            <input type="checkbox" id="case-engraving-upcharge" name="properties[Case Engraving Up Charge]" value="20.0" class="js-upcharge-checkbox" data-part-name="Case Engraving">


            <input type="hidden" name="properties[_engraving-price-part_twilight-matte]" id="engraving-price-part_twilight-matte" data-base-part-number="ENGRAVING" value="ENGRAVING"></input>
            <input type="hidden" name="properties[_engraving-text-part_twilight-matte]" id="engraving-text-part_twilight-matte" value=""></input>
            <input type="hidden" name="properties[_engraving-part-number-part_twilight-matte]" id="engraving-part-number-part_twilight-matte" value=""></input>
            <input type="hidden" name="properties[_engraving-color-part_twilight-matte]" id="engraving-color-part_twilight-matte" value=""></input>
            */


        }

        function toggleMustPaintMessage(partSEName) {
            let parentSEName = $(`.palette .engTextArea-${partSEName}`).data("parentsename"), parentColor, textColor;
            if (parentSEName === undefined) { return false; }
          
            $(`.partColorOptions.part-${parentSEName} `).children(":selected").each(function () {
                parentColor = $(this).data("sename");
            });
          
            textColor = cwColors[parentColor].engravingtext;
            if (textColor === "no-engraving") {
                $(`.palette .part-${partSEName}`).removeClass("disableEngraving").removeClass("allowEngraving").addClass("disableEngraving");
                $(`.part-${partSEName} textarea`).val("");                    
            } else {
                $(`.palette .part-${partSEName}`).removeClass("disableEngraving").removeClass("allowEngraving").addClass("allowEngraving");
            }
        }

        function checkLastPartLogic () {
            let partPanel = $(".palette > ul"), partsScrollLeft = partPanel.scrollLeft(), partsWidth = partPanel.width(), rndCurScroll = 0, rndFullWidth = 0;
            let newScrollLeft = partsScrollLeft + (partsWidth), mainPalette = $(".palette"), partPanelLength = $(".palette > ul > li").length;

            rndCurScroll = (Math.round(newScrollLeft/20) + Math.round(partsWidth/20)) * 20;
            rndFullWidth = Math.round((partsWidth*partPanelLength)/20) * 20;

            if (rndCurScroll <= rndFullWidth) {
                mainPalette.removeClass("onLastPart");
            } else {
                mainPalette.addClass("onLastPart");
            }
        }

        function symbolSelected() {            
            let partSEName, curText, engTextArea, startPos, endPos, newCursorPos;
            partSEName = $(this).parent().data("partsename");
            engTextArea = $(`.engTextArea-${partSEName}`)[0];
            startPos = engTextArea.selectionStart;
            endPos = engTextArea.selectionEnd;
            curText = engTextArea.value;
            
            engTextArea.value = curText.substring(0, startPos) + $(this).data("code") + curText.substring(endPos, curText.length);

            newCursorPos = startPos + $(this).data("code").length;
            engTextArea.selectionStart = newCursorPos;
            engTextArea.selectionEnd = newCursorPos;

            $(engTextArea).trigger("propertychange");
            $(engTextArea).focus();
        }

        function movePreviousPart() {
            let partPanel = $(".palette > ul"), partsScrollLeft = partPanel.scrollLeft(), partsWidth = partPanel.width();
            partPanel.toggleClass("scrollMode");
            partPanel.animate({scrollLeft: partsScrollLeft - (partsWidth)}, 300, function() { 
                partPanel.toggleClass("scrollMode");
                //paletteScroll();
                //checkLastPartLogic();
            });
        }
            
        function moveNextPart() {
            let mainPalette = $(".palette"), partPanel = $(".palette > ul"), partsScrollLeft = partPanel.scrollLeft(), partsWidth = partPanel.width();
            let newScrollLeft = partsScrollLeft + (partsWidth);

            if (mainPalette.hasClass("onLastPart")) {
                toggleAllParts();
                return false;
            }

            partPanel.toggleClass("scrollMode");
            partPanel.animate({scrollLeft: newScrollLeft}, 300, function() {
                partPanel.toggleClass("scrollMode");
                //paletteScroll();
                //checkLastPartLogic();
            });
        }
            
        function toggleAllParts() {
            $("#cwDesignStudio").toggleClass("allPartsMode");
        }

        function updateProductPriceSub2() {
            updateProductPrice();
        }
        function updateProductPriceSub() {
            updateProductPrice();
        }
        function updateProductPrice() {
        //this.updateProductPrice = function() {
            if (typeof $(".cwDSFinalPrice span").html() !== 'undefined') {
                $(".bfPrice").html($(".cwDSFinalPrice span").html().replace(".00", ""));
            }
          
            if (typeof $("product-info .price__regular .price-item").html() !== 'undefined') {
                let totalUpcharge = 0.0;
                let totalPriceText = $("product-info .price__regular .price-item").html().trim();
                let totalPrice = parseFloat(totalPriceText.replace(/[^\d.]/g, ''));
                /*
                $('.bcpo input[type="checkbox"]:checked').each(function() {
                    let partPrice = $(this).data('price');
                    totalUpcharge += parseFloat(partPrice);
                });
                */
                $('.js-upcharge-checkbox:checked').each(function() {
                    let partPrice = $(this).val();
                    totalUpcharge += parseFloat(partPrice);
                });

                $("#product-up-charges").val(parseFloat(totalUpcharge));



                totalPrice += parseFloat(totalUpcharge);
                $(".bfPrice").html("$" + totalPrice.toFixed(0));
              
            }
        };

        /*
        function updateTextAreas(textAreaChanged) {          
            clearTimeout(engTimer);
            engTimer = setTimeout(function() {
                partTextChanged(textAreaChanged);
                drawAllDSImages();
                updateSelectedColorsPalette();
            }, 150);
        }
        */
        const debouncedUpdateTextAreas = debounce((textAreaChanged) => {
            partTextChanged(textAreaChanged);
            drawAllDSImages();
            updateSelectedColorsPalette();
        }, 150);

        /*
        function loadColorsFromCode(colorCode) {
            let arrColors, kitGroupId, kitItemID, variantDiscount;

            if (colorCode === "" || colorCode === undefined) {
                return false;
            }
            arrColors = colorCode.split("*");
            jQuery.each(arrColors, function (index, value) {
                if (arrColors[index].indexOf("-") === -1) {
                    return false;
                }
                arrColors[index] = value.split("-");
                if (arrColors[index][0] === 'variant') {
                    kitItemID = parseInt(arrColors[index][1], 36);
                    $(`input[name="VariantId"]`).prop("value", kitItemID);
                    $(`.variantSwatch[data-variant-id='${kitItemID}']`).each( function () {
                        variantDiscount = $(this).data("variant-discount");
                        $(`.salePrice span`).html(`$${variantDiscount} off`);
                    });                    
                } else {
                    kitGroupId = parseInt(arrColors[index][0], 36);
                    kitItemID = parseInt(arrColors[index][1], 36);

                    //$(`#kitgroup-dropdown-${kitGroupId}`).val(kitItemID).change();
                    $(`#kitgroup-dropdown-${kitGroupId}`).val(kitItemID);
                }

            });
            drawAllDSImages();
            updateSelectedColorsPalette();
        }
        */



        function disablePaletteScroll() {
            let partPanel = $(".palette > ul");
            partPanel.removeClass("scrollMode");
        }
        function enablePaletteScroll() {
            let partPanel = $(".palette > ul");
            partPanel.addClass("scrollMode");
        }

        function applyGalleryColors() {
            let colorCode = $(this).find("img").data("url");
            $("html").animate({ scrollTop: 0 }, 700, function() {
                //loadColorsFromCode(colorCode);
            });
          
        }
        function selectPartHeading() {
            let headingParentSEName = $(this).data("sename"), animate = false;
            toggleAllParts();
            showPalettePart(headingParentSEName, animate); 
        }

        function clearEngraving() {
            let engPartSEName = $(this).data("partsename"), engPartTextArea = $(`.engTextArea-${engPartSEName}`);
            engPartTextArea.val("");
            //engravingImages = {};
            for (const prop in engravingImages) {
                if (engravingImages.hasOwnProperty(prop)) {
                    delete engravingImages[prop];
                }
            }
            //updateTextAreas(engPartTextArea);
            debouncedUpdateTextAreas(engPartTextArea);
        }

        
        function removePart() {
            $(this).parents(".hasOffOption").find(".isOffOption").trigger("click");
            $(this).parents(".hasOffOption").find(".engClear").trigger("click");
            return false;
        }        

        function setCSSProperties() {

            let swatchSize, paletteColumns;



            if (window.matchMedia("(orientation: portrait)").matches) {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthPortrait').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);
            // you're in PORTRAIT mode
            } else {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthLandscape').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);

            }

            paletteColumns = Math.floor(Math.floor($(".part-options").width()/swatchSize)/2)*2;
            document.documentElement.style.setProperty('--column', paletteColumns);


            



            
            let trueVH = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${trueVH}px`);

            let productTitleLength = $(`.title h3`).text().length;
            document.documentElement.style.setProperty('--productTitleLength', `${productTitleLength}`);


        }
        function variantSelect() {
            const newVariantSEName = $(this).data("variant-sename");
            $(`#VariantSEName`).prop("value", $(this).data("variant-sename"));

            let discount = $(this).data("variant-discount");
            if (discount) {
                $(`.salePrice span`).html(`$${discount} off`);
            }
            
            drawAllDSImages();
            updateSelectedColorsPalette();
            updateDesignURL();
        }
        function addToCart() {
            //createCombinedImage();      
            if (!$(".stickyAddToCart").hasClass("CheckoutClicked")) {
                if ($(".inventorySoldOutWarning").length === 0) {
                    $(".stickyAddToCart").addClass("CheckoutClicked");


                    for (const [key, value] of Object.entries(engravingImages)) {
                        $(`${key}`).prop("value", value);
                    }
                    
                    for (const [key, value] of Object.entries(cartImages)) {
                      if (key === ".cart-image-angle-1") {
                        $(`#cartImage`).prop("value", value);                        
                      }
                    }

                    const triggerAddToCart = () => {                        
                        $(`#cartImage`).prop("value", "");    
                        $(".js-add-to-cart-button").trigger("click");
                        $(".product-form__submit").trigger("click");
                    };
                    const checkImageAndProceed = (url, retries = 10, delay = 500) => {
                        return new Promise((resolve) => {
                            const checkImage = (attempt) => {

                                const uniqueUrl = `${url}?timestamp=${new Date().getTime()}`;

                                fetch(uniqueUrl, { method: 'HEAD' })
                                    .then(response => {
                                        if (response.ok) {
                                            resolve(true);
                                        } else {
                                            if (attempt < retries) {
                                                setTimeout(() => checkImage(attempt + 1), delay);
                                            } else {
                                                resolve(false);
                                            }
                                        }
                                    })
                                    .catch(() => {
                                        if (attempt < retries) {
                                            setTimeout(() => checkImage(attempt + 1), delay);
                                        } else {
                                            resolve(false);
                                        }
                                    });
                            };
                            checkImage(0);
                        });
                    };

                    if (!cwDS.hasProductImages) { //skip this step for images with a product image
                        
                        const lambdaUrl = 'https://ecl2plowwqejrwhhhpw2tuo7zi0lmutv.lambda-url.us-east-1.on.aws/'; // Replace with your actual function URL
                        var formData = new FormData();
                        var imageBlob = $(`#cartImage`).prop("value");
                        fetch(lambdaUrl, {
                            method: 'POST',
                            body: JSON.stringify({ image: imageBlob }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(response => response.json())
                        .then(data => {
                            // logic here to update cart image url
                            const shopifyUniqueFileName = data.uniqueFileName.replace(".jpeg", ".jpg");
                            const imageUrl = `https://cdn.shopify.com/s/files/1/0791/8367/5687/files/${shopifyUniqueFileName}`;
                            $('#cartImageFile').prop("value", imageUrl);
                            $(`#cartImage`).prop("value", "");
                            // Check if the image is ready
                            return checkImageAndProceed(imageUrl);
                        })
                        .then(imageReady => {
                            if (imageReady) {
                                triggerAddToCart();
                            } else {
                                $('#cartImageFile').prop("value", "");
                                triggerAddToCart();
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                            $('#cartImageFile').prop("value", "");
                            triggerAddToCart();
                        })
                        /*.finally(() => {
                            $(".js-add-to-cart-button").trigger("click");
                            $(".product-form__submit").trigger("click");
                        });*/
                    } else {
                        triggerAddToCart();
                        //$(".js-add-to-cart-button").trigger("click");
                        //$(".product-form__submit").trigger("click");
                    }


                }
            }
        }

        function scrollHandler(e) {
            let atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0, timeOut = atSnappingPoint ? 0 : 150;        
            clearTimeout(e.target.scrollTimeout);        
            e.target.scrollTimeout = setTimeout(function() {
                paletteScroll();
                checkLastPartLogic();
            }, timeOut);
        }

        function brainstorm() {
            // Clear text selection
            if (window.getSelection) { 
                if (window.getSelection().empty) {  // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }

            
            let partList = $(".kit-group").not(".kit-group[data-part-sename='hidden']");
            let chosenColors = [];

            partList.each(function () {
                var options = $(this).find(".partColorOptions").children('option').toArray();
                if (options.length > 0) {

                    // Select a random option
                    var selectedOption;
                    if (chosenColors.length < cwDS.brainstormCap) {

                        selectedOption = options[Math.floor(Math.random() * options.length)];
                        chosenColors.push($(selectedOption).data('sename'));
                    } else {
                        // Select from chosen colors
                        var chosenColor = chosenColors[Math.floor(Math.random() * chosenColors.length)];
                        selectedOption = $(this).find(".partColorOptions").children(`option[data-sename="${chosenColor}"]`).toArray();
            
                        // If no options with the chosen color exist in this dropdown, select a random option from all options
                        if (selectedOption.length === 0) {
                            selectedOption = options[Math.floor(Math.random() * options.length)];
                        } else {
                            selectedOption = selectedOption[Math.floor(Math.random() * selectedOption.length)];
                        }
                    }
                    $(this).find(".partColorOptions").val(selectedOption.value);
                }

            });
            drawAllDSImages();
            updateSelectedColorsPalette();

        }
        function brainstormMode() {
            $("#cwDesignStudio").addClass("brainstormMode");

        }


        function tripleClick(callbackFunctionName) {
            var clicks = 0; // counter for clicks
            var delay = 500; // delay in milliseconds for detecting triple click
            return function() {
                clicks++;
                if (clicks === 1) {
                    setTimeout(function() {
                        if (clicks === 3) {
                            callbackFunctionName();
                        }
                        // Reset counter
                        clicks = 0;
                    }, delay);
                }
            };
        }

        function attachDSEvents() {
            $("section.title").off("click").on("click", tripleClick(brainstormMode) );
            $(".addDesign").off("click").on("click", brainstorm );
            $(".partColorOptions").off("change").on("change", drawAllDSImages );
            $(".kit-text-area").off("input propertychange").on("input propertychange", drawAllDSImages );
            $(".part-options li").off("click").on("click", colorSwatchSelected );
            //$(".part-options textarea").off("input propertychange").on("input propertychange", function() { updateTextAreas(this); } );
            //$(".part-options .inTextarea").off("input propertychange").on("input propertychange", function() { updateTextAreas(this); } );
            $(".part-options textarea").off("input propertychange").on("input propertychange", function() { debouncedUpdateTextAreas(this); } );
            $(".part-options .inTextarea").off("input propertychange").on("input propertychange", function() { debouncedUpdateTextAreas(this); } );
            $(".part-options textarea").off("mousedown").on("mousedown", disablePaletteScroll );
            $(document).off("mouseup").on("mouseup", enablePaletteScroll );
            $(".palette nav .previousPart").off("click").on("click",  movePreviousPart );
            $(".palette nav .allParts").off("click").on("click", toggleAllParts );
            $(".palette nav .nextPart").off("click").on("click",  moveNextPart );
            $(".palette h4").off("click").on("click", selectPartHeading );
            $(".palette .variantSwatch").off("click").on("click", variantSelect );
            $(".symbolList li").off("click").on("click", symbolSelected );
            //$(".product__info-container").off("DOMSubtreeModified").on("DOMSubtreeModified",  updateProductPriceSub /*function() { this.updateProductPrice(); }*/ );

            
            //$(".js-kit-summary").off("DOMSubtreeModified").on("DOMSubtreeModified",  updateProductPriceSub2 /*function() { this.updateProductPrice(); }*/ );
            $(".bcpo input").off("change").on("change",  /*updateProductPrice*/ function() { this.updateProductPrice(); } );
            $(".js-upcharge-checkbox").off("change").on("change",  updateProductPrice /*function() { this.updateProductPrice(); }*/ );
            $(".mediaLoadDesign").off("click").on("click",  applyGalleryColors );
            $(".engClear").off("click").on("click",  clearEngraving );
            $(".removePartText").off("click").on("click", removePart );
            $(".stickyAddToCart").off("click").on("click", addToCart );
            $(".scrollMode").off("scroll").on("scroll", scrollHandler );


            $(window).off("orientationchange resize").on("orientationchange resize", setCSSProperties );
            
            
            $(window).off("blur").on("blur", function(){
                createCombinedImage();
                if (typeof ga === 'function') {
                    ga('send', 'event', "UI", "Window Blur");
                }
            });

            $(".partColorOptions").on("change", function() {
                updateDesignURL();
            });
            $(".kit-text-area").on("input propertychange", function() {
                // Use a small delay to avoid too many URL updates while typing
                clearTimeout(window.urlUpdateTimer);
                window.urlUpdateTimer = setTimeout(updateDesignURL, 500);
            });


        }

        function createPalette() {
            let partList = $(".kit-group").not(".kit-group[data-part-sename='hidden']");
            updateSelectedColorsPalette();


            partList.each(function () {
                let part = $(this), partSelect = part.find(".partColorOptions"), partName = part.data("part-name"), partSEName = part.data("part-sename"), colorArray = [], selectedColorSE;
                let ulColorList, sectionColorList, h5ColorList, colorCategoryNote, textAreas = part.find(".partTextOptions");

                $(`.part-${partSEName} `).removeClass("hasOffOption");                
                partSelect.children(":selected").each(function () {
                    selectedColorSE = $(this).data("sename");
                });

              

              
                partSelect.children().each(function () {
                    let partColor =  $(this).data("sename"), partColorLookup = partColor, partName =  $(this).data("name"), colorObj, isSelectedColor;

                    if ($(this).data("finish") === "skin") { partColorLookup = `${partColor}-skin`; }
                    if ($(this).data("finish") === "style") { partColorLookup = `${partColor}-style`; }

                    colorObj = cwColors[partColorLookup];
                    isSelectedColor = selectedColorSE === partColor;
                    if (colorObj !== undefined) {
                        colorArray.push( { 
                            category: colorObj.category, 
                            displayorder: colorObj.displayorder, 
                            sename: partColor, 
                            name: partName, 
                            value: $(this).val(), 
                            selected: isSelectedColor, 
                            offoption: colorObj.offoption
                        } );
                    }
                });
                

              
                for (let i=0; i<colorArray.length; i++) {
                    let liColor = document.createElement("li"), optionsClasses = "";
                    ulColorList = $(`.part-${partSEName} .part-options ul.cat-${colorArray[i].category}`);                    

                    if (ulColorList.length === 0) {
                        sectionColorList = document.createElement("section");
                        sectionColorList.className = `cat-${colorArray[i].category}`;
                        sectionColorList.style.order = cwCategories[colorArray[i].category].displayorder;
                        colorCategoryNote = document.createElement("p");
                        colorCategoryNote.appendChild(document.createTextNode(cwCategories[colorArray[i].category].note));
                        h5ColorList = document.createElement("h5");
                        h5ColorList.appendChild(document.createTextNode(colorArray[i].category));
                        ulColorList = document.createElement("ul");
                        ulColorList.className = `cat-${colorArray[i].category}`;
                        ulColorList.dataset.partsename = partSEName;
                        sectionColorList.appendChild(h5ColorList);
                        sectionColorList.appendChild(ulColorList);
                        if (colorCategoryNote !== '') {
                            sectionColorList.appendChild(colorCategoryNote);
                        }
                        $(`.part-${partSEName} .part-options`).append(sectionColorList);
                    }

                    liColor.appendChild(document.createTextNode(colorArray[i].name));
                    if (colorArray[i].selected) {
                        optionsClasses = `isSelected ${optionsClasses}`;
                    }
                    if (colorArray[i].offoption === "true") {
                        optionsClasses = `isOffOption ${optionsClasses}`;
                        $(`.part-${partSEName} `).addClass("hasOffOption");
                        if (colorArray[i].selected) {
                            $(`.part-${partSEName} `).addClass("offOptionSelected");
                        }
                    }
                    liColor.className = `${optionsClasses} colorSwatch color${colorArray[i].sename}  ${colorArray[i].category}`;                    
                    liColor.title = colorArray[i].name;
                    liColor.dataset.value = colorArray[i].value;
                    liColor.style.order = colorArray[i].displayorder;
                    ulColorList.append(liColor);
                }

                textAreas.each(function () {
                    let parentPartName, partTextArea, liText, partTextClear, liTextClear, removeIcon, liSymbols, ulSymbols, pSymbols, detailsLink, sectionSymbols, divMustPaintMessage, divMustPaintMessageContent, pMustPaintNote, buttonMustPaint;
                    
                    parentPartName = capitalizeWords(partSEName.replace("-engraving", '').replace("-", " "));
                    partTextArea = document.createElement("textarea");                    

                    partTextArea.dataset.partsename = partSEName;                    
                    partTextArea.dataset.parentsename = $(this).data("parentsename");

                    partTextArea.className = ` fa inTextarea paletteEngArea engTextArea-${partSEName}`;
                    partTextArea.placeholder = `Enter Custom Engraving Here`;
                    liText = document.createElement("li");                    

                    sectionColorList = document.createElement("section");
                    sectionColorList.className = "cat-text";
                    
                    h5ColorList = document.createElement("h5");
                    h5ColorList.appendChild(document.createTextNode(`${partName} Text`));
                    
                    ulColorList = document.createElement("ul");
                    //sectionColorList.appendChild(partTextArea);

                    sectionColorList.appendChild(h5ColorList);
                    liText.appendChild(partTextArea);

                    partTextClear = document.createElement("button");
                    liTextClear = document.createElement("li");
                    
                    partTextClear.dataset.partsename = partSEName;                    
                    partTextClear.dataset.parentsename = $(this).data("parentsename");
                    partTextClear.className = "engClear";


                    removeIcon = document.createElement("i");
                    removeIcon.className = "fas fa-trash-alt";

                    //<i class="fas fa-trash-alt"></i>
                    partTextClear.appendChild(removeIcon);
                    partTextClear.appendChild(document.createTextNode(` Remove`));

                    liTextClear.appendChild(partTextClear);

                    //cwSymbols                     
                    sectionSymbols = document.createElement("section");
                    ulSymbols = document.createElement("ul");
                    ulSymbols.className = "symbolList";                    
                    ulSymbols.dataset.partsename = partSEName;
                    for (let symbol in cwSymbols) {
                        liSymbols = document.createElement("li");
                        //liSymbols.className = `fa${cwSymbols[symbol].mod} fa-${symbol} symbol${symbol}`;          
                        liSymbols.className = `fa fa-${symbol} symbol${symbol}`;      
                        liSymbols.dataset.code = cwSymbols[symbol].code;
                        liSymbols.style.order = cwSymbols[symbol].displayorder;
                        ulSymbols.appendChild(liSymbols);
                    }
                    sectionSymbols.appendChild(ulSymbols);
                    ulColorList.appendChild(liText);
                    ulColorList.appendChild(liTextClear);
                    sectionColorList.appendChild(ulColorList);
                    divMustPaintMessage = document.createElement("div");
                    divMustPaintMessage.className = "mustPaintMessage";
                    divMustPaintMessageContent = document.createElement("div");
                    divMustPaintMessageContent.className = "message-content";
                    pMustPaintNote = document.createElement("p");
                    pMustPaintNote.appendChild(document.createTextNode(`To add engraving, the ${parentPartName} must first be painted. Would you like to paint it now?`));
                    pSymbols = document.createElement("p");
                    pSymbols.className = "engraving-policy-message";
                    pSymbols.appendChild(document.createTextNode(`Engraved items are non-returnable.  `));
                    detailsLink = document.createElement("a");
                    detailsLink.href = "/support";
                    detailsLink.appendChild(document.createTextNode("Details"));
                    pSymbols.appendChild(document.createTextNode(`[`));
                    pSymbols.appendChild(detailsLink);
                    pSymbols.appendChild(document.createTextNode(`]`));
                    sectionSymbols.appendChild(pSymbols);
                    buttonMustPaint = document.createElement("button");
                    buttonMustPaint.className = "engraving-paint-part";
                    buttonMustPaint.dataset.parent = parentPartName.toLowerCase().replace(" ", "-");
                    buttonMustPaint.appendChild(document.createTextNode(` Paint ${parentPartName} `));
                    divMustPaintMessageContent.appendChild(pMustPaintNote);
                    divMustPaintMessageContent.appendChild(buttonMustPaint);
                    divMustPaintMessage.appendChild(divMustPaintMessageContent);

                    $(`.part-${partSEName} .part-options`).append(sectionColorList);
                    $(`.part-${partSEName} .part-options`).append(sectionSymbols);
                    $(`.part-${partSEName} .part-options`).append(divMustPaintMessage);
                    $(`.part-${partSEName} `).addClass("hasOffOption");
                    $(`.part-${partSEName} `).addClass("offOptionSelected");
                    
                    $(".engraving-paint-part ").off("click").on("click", function () {
                        let partName, animate = true;
                        partName = $(this).data("parent");
                        showPalettePart(partName, animate);
                    });
                });
            });            
            setCSSProperties();
            attachDSEvents();
        }

        function createStudio() {
            let studio = $(".studio"), partList = $(".kit-group"), angleArray = [], angleUL, angleLI, angleIMG, angleDIV, dsImageW = fixDSImgSize("size-2560", 0);
            partList.each(function () {
                let thisOBJ = $(this);
                angleArray[thisOBJ.data("angle")-1] = thisOBJ.data("angle");
            });
            if (angleArray.length === 0) {                
                if ($(".part-variant").length === 0) {
                    $("#cwDesignStudio").addClass("dsHasNoParts");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                } else {
                    $("#cwDesignStudio").addClass("dsHasOnePart");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                }
                angleArray[0] = 1;
            }


            angleUL = document.createElement("ul");
            angleUL.className = "scrollMode";
            for (let i=0; i<angleArray.length; i++) {
                angleLI = document.createElement("li");
                angleLI.className = ` angle${angleArray[i]} `;
                angleIMG = document.createElement("img");
                angleIMG.id = `dsAngle${angleArray[i]}Img`;
                angleDIV = document.createElement("div");
                angleDIV.className = "dsPartMap";
                angleDIV.title = cwDS.productName;
                angleDIV.dataset.src = `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angleArray[i]}/part-map.svg`;
                angleLI.appendChild(angleIMG);
                angleLI.appendChild(angleDIV);
                angleUL.appendChild(angleLI);
            }
            studio.append(angleUL);
        }
/*
        function loadColorURL() {
            let colorCode = getRequestValue("c");
            loadColorsFromCode(colorCode);
        }
*/
        this.setupDesignStudio = function() {


            setCSSProperties();
            //loadColorURL();


            /*createCombinedImageWithValues();*/


            loadDesignFromURL();
            createPalette();
            createStudio();
            loadPartMap();
            drawAllDSImages();
            attachDSEvents();
            
            updateSelectedColorsPalette();
            updateProductPrice();
        };
        this.setupDesignStudio();
        this.initMutationObserver();
    }
/*
    $(function () {
        new CWDESIGNSTUDIO();
    });
*/
    window.onload = function() {
        new CWDESIGNSTUDIO();
    };
    

}());
